/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-12-17 11:43:17
 */
import md5 from 'js-md5';
const state = {
    baseInfo: {
        appName: 'AneuPlan',
        version: '1.1.0',
        companyName: '杭州脉流科技有限公司',
        organizationName: '', //机构名称
        organizationNickName: '', //机构英文名称
        organizationLogo: null,
    },
    viewTabs: [], //tabs-view标签展示
    themeColor: '#409EFF', //主题颜色，默认 #409EFF
    menuRelated: {
        isCollapse: false, //是否收起菜单
        collapseText: '收起菜单', //展开或收起时的title文案
        leftMenuWid: '220px', //左侧菜单宽度
    },
    contentTableHei: 500, //内容区表格的高度
    pageSize: 10, //分页组件每页显示条目个数
    pageBaseSize: 10, //每页条目数的最小基数
    rolePermission: null, //角色权限（超级管理员：superAdministrator，操作员：operator，普通用户：ordinaryUsers）
    roleID: null, //角色id
    tableIdArr:[],//设置能访问的bid
}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js